module.exports = __webpack_public_path__ + "img/IMÁGENES CLÍNICAS KU1 2.14e3775f.png";